import React from 'react';
import { Dialog } from '../Modal/Modal';
import { __resolve } from '@/lib/i18n';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'destructive' | 'danger';
  isLoading?: boolean;
  /** data-testid for the confirm button — used for targeted Playwright selectors. */
  confirmTestId?: string;
  /** data-testid for the cancel button — used for targeted Playwright selectors. */
  cancelTestId?: string;
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = __resolve('ui::Confirm'),
  cancelText = __resolve('ui::Cancel'),
  variant = 'primary',
  isLoading = false,
  confirmTestId,
  cancelTestId,
}: ConfirmDialogProps) {
  const handleConfirm = () => {
    onConfirm();
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={title}
      description={description}
      confirmText={confirmText}
      cancelText={cancelText}
      confirmVariant={variant}
      isLoading={isLoading}
      confirmTestId={confirmTestId}
      cancelTestId={cancelTestId}
      size="sm"
    />
  );
}
